export default __webpack_public_path__ + "img/e9698a1252488cba378ebfab03ae590c.svg";